import React, { useState, useEffect, useRef } from 'react';
import './CustomerReviewCarousel.scss';

const initialReviews = [
  {
    avatar: "https://firebasestorage.googleapis.com/v0/b/content-filter-154e4.appspot.com/o/assets%2FProperty_sales_happy_client_2.jpg?alt=media&token=260ed8cf-05db-4391-937e-fd7e9e9be6e9",
    name: 'Georgia',
    rating: 5,
    text: 'I would definitely recommend Your Move in Durham. Ian, Nicky and Annaleigh were excellent the customer service was brilliant. Very helpful!',
  },
  {
    avatar: "https://firebasestorage.googleapis.com/v0/b/content-filter-154e4.appspot.com/o/assets%2FProperty_sales_happy_client_7.jpg?alt=media&token=e380b775-6804-4e4a-afd3-5f26def1cd5f",
    name: 'David',
    rating: 5,
    text: 'Selling or buying houses can be tricky, but yet again Your Move (Consett) have made this process effortless.',
  },
  {
    avatar: "https://firebasestorage.googleapis.com/v0/b/content-filter-154e4.appspot.com/o/assets%2FProperty_sales_happy_client_3.jpg?alt=media&token=60da15ef-c4fc-40f0-9c03-c7fbe8b43b9f",
    name: 'Christine',
    rating: 5,
    text: 'A superb estate agents. Sam has been fantastic, she has remained professional but relatable.',
  },
  {
    avatar: "https://firebasestorage.googleapis.com/v0/b/content-filter-154e4.appspot.com/o/assets%2FProperty_sales_happy_client_4.jpg?alt=media&token=60a8a979-a301-4779-a702-60a77ba3f568",
    name: 'Will',
    rating: 5,
    text: 'I had a very pleasant experience with Dan throughout my time using Your Move and would recommend it to friends.',
  },
  {
    avatar: "https://firebasestorage.googleapis.com/v0/b/content-filter-154e4.appspot.com/o/assets%2FProperty_sales_happy_client_6.jpg?alt=media&token=e99005cb-5f2a-442e-8360-7747f4b6827e",
    name: 'Rachel',
    rating: 5,
    text: "Such a friendly and talented team, over the moon with the marketing of our property which has sold so quickly. ",
  },
  {
    avatar: "https://firebasestorage.googleapis.com/v0/b/content-filter-154e4.appspot.com/o/assets%2FProperty_sales_happy_client_5.jpg?alt=media&token=b534173b-b2df-4828-a969-f06dbb281ad5",
    name: 'Linda',
    rating: 5,
    text: 'I cannot praise Your Move Wallsend enough. From the first phone call to arrange a valuation to completion today we have had excellent service.',
  },
];

const CustomerReviewCarousel = () => {
  const [reviews] = useState([...initialReviews]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const carouselRef = useRef(null);

  const getVisibleItemsCount = () => {
    if (window.innerWidth <= 768) {
      return 1;
    } else if (window.innerWidth <= 1024) {
      return 2;
    }
    return 3;
  };

  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 5000); // Auto-scroll every 5 seconds
    return () => clearInterval(interval);
  }, []);

  const nextSlide = () => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setCurrentIndex((prevIndex) => prevIndex + 1);
  };

  const prevSlide = () => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setCurrentIndex((prevIndex) => prevIndex - 1);
  };

  useEffect(() => {
    const handleTransitionEnd = () => {
      setIsTransitioning(false);
      const visibleItemsCount = getVisibleItemsCount();
      const totalItems = reviews.length;
      const maxIndex = window.innerWidth <= 768 ? totalItems  : totalItems; // Adjust the threshold for smaller screens
  
      if (currentIndex >= maxIndex) {
        setCurrentIndex(0);
        carouselRef.current.style.transition = 'none';
        setTimeout(() => {
          carouselRef.current.style.transition = 'transform 0.5s ease-in-out';
        }, 0);
      } else if (currentIndex < 0) {
        setCurrentIndex(totalItems - visibleItemsCount);
        carouselRef.current.style.transition = 'none';
        setTimeout(() => {
          carouselRef.current.style.transition = 'transform 0.5s ease-in-out';
        }, 0);
      }
    };
  
    if (carouselRef.current) {
      carouselRef.current.addEventListener('transitionend', handleTransitionEnd);
    }
  
    return () => {
      if (carouselRef.current) {
        carouselRef.current.removeEventListener('transitionend', handleTransitionEnd);
      }
    };
  }, [currentIndex, reviews.length]);
  

  const visibleItemsCount = getVisibleItemsCount();

  
  const getTranslateXPercentage = () => {
    const visibleItemsCount = getVisibleItemsCount();
    if (window.innerWidth <= 768) {
      return (currentIndex * 25) / visibleItemsCount; // Halve the movement for small screens
    }
    return (currentIndex * 100) / visibleItemsCount;
  };
  
  const translateXPercentage = getTranslateXPercentage();

  return (
    <div className="carousel-wrapper">
      <div className="carousel-header">
        <h2>Don't just take our word for it</h2>
        <p>Your Move Chris Stonock has over 2000 5-star reviews on Google and Trustpilot.</p>
      </div>
      <div className="carousel-container">
        <button className="prev-unique" onClick={prevSlide}>
          &#10094;
        </button>
        <div className="carousel">
          <div
            className="carousel-inner"
            ref={carouselRef}
            style={{ transform: `translateX(-${translateXPercentage}%)` }}
          >
            {reviews.map((review, index) => (
              <div className="carousel-item" key={index}>
                <div className="avatar-container">
                  <img src={review.avatar} alt={`${review.name}'s review`} className="avatar" />
                </div>
                <div className="review-content">
                  <div className="rating">
                    {'★'.repeat(review.rating) + '☆'.repeat(5 - review.rating)}
                  </div>
                  <p>{review.text}</p>
                  <div className="reviewer-info">
                    <span className="reviewer-name">{review.name}</span>
                    {/* <span className="review-source">Google</span> */}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <button className="next-unique" onClick={nextSlide}>
          &#10095;
        </button>
      </div>
    </div>
  );
};

export default CustomerReviewCarousel;
